import { Typography } from '@mui/material';
import ReactCountryFlag from 'react-country-flag';

type Props = {
  countryCode: string;
  otherProps?: any;
  currency?: string;
};

const CountryFlag = ({ countryCode, otherProps, currency }: Props) => {
  return (
    <>
      <ReactCountryFlag countryCode={countryCode} {...(otherProps || {})} svg />
      {currency && (
        <Typography component="span" sx={{ display: 'inline-block', ml: 1 }}>
          ({currency.toUpperCase()})
        </Typography>
      )}
    </>
  );
};

export default CountryFlag;
